import React, { Component, PropTypes } from 'react';

export default class SelectField extends Component {
    static propTypes = {
        val: PropTypes.any.isRequired,
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        help: PropTypes.string.isRequired
    };

    state = {
        val : ''
    };

    componentDidMount() {
        this.setState({
            val: this.props.val
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            val: nextProps.val
        });
    }

    handlerOnChange = (e) => {
        this.setState({ val: e.target.value });

        if (this.props.onChange) {
            this.props.onChange(e);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    render() {
        let hasError = '';

        if(this.props.hasError === true) {
            hasError = 'has-error';
        }
        
        return (
            <div className={"form-group form-md-line-input " + hasError}>
                <select id={this.props.id} className="form-control" multiple={this.props.multiple} value={this.state.val}
                        onChange={this.handlerOnChange}
                        name={this.props.id}>

                    {this.props.options.map((item, i) => {
                        return (
                            <option value={item.value} key={i}>{item.label}</option>
                        )
                    })}
                </select>
                <label htmlFor={this.props.id}>{this.props.label}</label>
                <span className="help-block">{this.props.help}</span>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/SelectField.js
 **/